<template>    
    <a v-if="value" :href="compHref">{{value}}</a>
</template>

<script setup>
// import Phone from "@controls/text/Phone.vue";
//     <Phone v-model="phone"></Phone>
import {computed} from 'vue'

const props = defineProps({
    value: {
        type: [String, Number]
    },
})
const compHref = computed({
    get() {
        return `tel:${props.value}`
    }
})

</script>